import template from './loansCatalog.html';
import controller from './loansCatalog.controller';
import './loansCatalog.scss';

let loansCatalogComponent = {
  restrict: 'E',
  bindings: {
    serviceClosed: '<'
  },
  template,
  controller
};

export default loansCatalogComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansCatalog/loansCatalog.component.js